import packageJson from '../../../../package.json'

export function Footer() {
  return (
    <footer className="flex items-center justify-center py-2 bg-transparent border-border/50">
      <div className="text-sm text-muted-foreground">
        <span>Version {packageJson.version}</span>
      </div>
    </footer>
  )
}

